import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { imgUrl , baseURLCats } from "../config/api";
import { convertToPersian } from "../Functions/TextTransform";

function CurtainSelection() {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  let navigate = useNavigate();
  const [pageLanguage, setPageLanguage] = useState(
    location.pathname
      .split("")
      .slice(1, 3)
      .join("")
  );
  const { catID } = useParams();
  const [models, setModels] = useState([]);
  const [modelList, setModelList] = useState([]);
  const [defaultModelName, setDefaultModelName] = useState("");
  const [defaultModelNameFa, setDefaultModelNameFa] = useState("");
  const [defaultDesc, setDefaultDesc] = useState("");
  const [defaultDescFa, setDefaultDescFa] = useState("");

  const getCats = async () => {
    console.log(`catID`, catID);
    try {
      const response = await axios.get(baseURLCats, {
        params: {
          pageName: catID,
        },
      });

      if (!response.data["ChildPages"]?.length) {
        setModelList(<p>No Page Item</p>);
        return;
      }

      let childPages = [...response.data["ChildPages"]];
      const hasSelectionOptions = childPages.some((page) => page.ShowWithChild === false);

      // Selection images for 0321 live under the model page (e.g. doubleeuropeanpleatedDrapery),
      // not under parent categories like all-drapery.
      if (!hasSelectionOptions) {
        const model0321 = childPages.find(
          (page) => page.Link === "0321" && page.PageName && page.PageName !== "null"
        );

        if (model0321) {
          const modelDetail = await axios.get(baseURLCats, {
            params: {
              pageName: model0321.PageName,
            },
          });
          const selectionPages = (modelDetail.data["ChildPages"] || []).filter(
            (page) => page.ShowWithChild === false
          );
          childPages = [...childPages, ...selectionPages];
        }
      }

      setModels(childPages);
      setDefaultModelName(response.data["EnTitle"]);
      setDefaultModelNameFa(convertToPersian(response.data["Title"]));
      setDefaultDesc(response.data["DescriptionEn"]);
      setDefaultDescFa(convertToPersian(response.data["Description"]));
    } catch (err) {
      console.log(err);
      navigate("/" + pageLanguage);
    }
  };

  function renderModels() {
    const modelLists = [];
    const selectionOptions = models.filter((page) => page.ShowWithChild === false);

    const normalizeText = (value) =>
      (value || "").toLowerCase().replace(/[&\s_-]/g, "");

    const findSelectionPage = (type) =>
      selectionOptions.find((page) => {
        const text = `${normalizeText(page.PageName)} ${normalizeText(page.EnTitle)}`;
        const hasSheer = text.includes("sheer");
        const hasDrapery = text.includes("drapery");

        if (type === "both") return hasSheer && hasDrapery;
        if (type === "sheers") return hasSheer && !hasDrapery;
        if (type === "drapery") return hasDrapery && !hasSheer;
        return false;
      });

    const getSelectionImageUrl = (page) =>
      !page?.ImageUrl
        ? `${process.env.PUBLIC_URL}/no_image.svg`
        : imgUrl(page.ImageUrl);

    const getSelectionTitle = (page, fallbackFa, fallbackEn) =>
      i18n.language === "fa"
        ? convertToPersian(page?.Title || fallbackFa)
        : page?.EnTitle || fallbackEn;

    for (let i = 0; i < models.length; i++) {
      let SewingModelId = models[i].Link;
      let WebsitePageItemId = models[i].WebsitePageId;
      let pageLanguage = location.pathname
        .split("")
        .slice(1, 3)
        .join("");

      if (SewingModelId === "0099") {
        const draperyPage = findSelectionPage("drapery");
        const sheersPage = findSelectionPage("sheers");
        const draperySheersPage = findSelectionPage("both");

        modelLists[0] = (
          <li
            key={"model" + 1}
            model_id={1}
            className={`${1 % 2 === 0 ? "model_color_1" : "model_color_2"}`}
          >
            <Link
              to={
                "/" +
                pageLanguage +
                "/Curtain/" +
                catID +
                "/" +
                SewingModelId +
                "/DraperyOnly" +
                "/Page-ID/" +
                WebsitePageItemId
              }
              className={`model_image_container 2`}
              onClick={() => sessionStorage.clear()}
            >
              <img
                src={getSelectionImageUrl(draperyPage)}
                className="img-fluid"
                alt=""
              />
            </Link>
            <div className={`model_info_container`}>
              <div className="model_item_info_container">
                <div className={`model_item_info_description_section`}>
                  {getSelectionTitle(draperyPage, "پرده پارچه\u200Cای", "Drapery")}
                </div>
                <Link
                  to={
                    "/" +
                    pageLanguage +
                    "/Curtain/" +
                    catID +
                    "/" +
                    SewingModelId +
                    "/DraperyOnly" +
                    "/Page-ID/" +
                    WebsitePageItemId
                  }
                  className="btn_normal model_item_btn_normal"
                  onClick={() => sessionStorage.clear()}
                >
                  {i18n.language === "fa" ? "مرحله بعدی" : "Continue"}
                </Link>
              </div>
            </div>
          </li>
        );
        modelLists[1] = (
          <li
            key={"model" + 2}
            model_id={2}
            className={`${2 % 2 === 0 ? "model_color_1" : "model_color_2"}`}
          >
            <Link
              to={
                "/" +
                pageLanguage +
                "/Curtain/" +
                catID +
                "/" +
                SewingModelId +
                "/SheersOnly" +
                "/Page-ID/" +
                WebsitePageItemId
              }
              className={`model_image_container 3`}
              onClick={() => sessionStorage.clear()}
            >
              <img
                src={getSelectionImageUrl(sheersPage)}
                className="img-fluid"
                alt=""
              />
            </Link>
            <div className={`model_info_container`}>
              <div className="model_item_info_container">
                <div className={`model_item_info_description_section`}>
                  {getSelectionTitle(sheersPage, "پرده تور", "Sheers")}
                </div>
                <Link
                  to={
                    "/" +
                    pageLanguage +
                    "/Curtain/" +
                    catID +
                    "/" +
                    SewingModelId +
                    "/SheersOnly" +
                    "/Page-ID/" +
                    WebsitePageItemId
                  }
                  className="btn_normal model_item_btn_normal"
                  onClick={() => sessionStorage.clear()}
                >
                  {i18n.language === "fa" ? "مرحله بعدی" : "Continue"}
                </Link>
              </div>
            </div>
          </li>
        );
        modelLists[2] = (
          <li
            key={"model" + 0}
            model_id={0}
            className={`${0 % 2 === 0 ? "model_color_1" : "model_color_2"}`}
          >
            <Link
              to={
                "/" +
                pageLanguage +
                "/Curtain/" +
                catID +
                "/" +
                SewingModelId +
                "/Drapery&Sheers" +
                "/Page-ID/" +
                WebsitePageItemId
              }
              className={`model_image_container 4`}
              onClick={() => sessionStorage.clear()}
            >
              <img
                src={getSelectionImageUrl(draperySheersPage)}
                className="img-fluid"
                alt=""
              />
            </Link>
            <div className={`model_info_container`}>
              <div className="model_item_info_container">
                <div className={`model_item_info_description_section`}>
                  {getSelectionTitle(
                    draperySheersPage,
                    "پرده تور و پارچه\u200Cای",
                    "Drapery & Sheers"
                  )}
                </div>
                <Link
                  to={
                    "/" +
                    pageLanguage +
                    "/Curtain/" +
                    catID +
                    "/" +
                    SewingModelId +
                    "/Drapery&Sheers" +
                    "/Page-ID/" +
                    WebsitePageItemId
                  }
                  className="btn_normal model_item_btn_normal"
                  onClick={() => sessionStorage.clear()}
                >
                  {i18n.language === "fa" ? "مرحله بعدی" : "Continue"}
                </Link>
              </div>
            </div>
          </li>
        );
      } else if (SewingModelId === "0321") {
        const draperyPage0321 = findSelectionPage("drapery");
        const sheersPage0321 = findSelectionPage("sheers");
        const draperySheersPage0321 = findSelectionPage("both");

        modelLists[0] = (
          <li
            key={"model" + 1}
            model_id={1}
            className={`${1 % 2 === 0 ? "model_color_1" : "model_color_2"}`}
          >
            <Link
              to={
                "/" +
                pageLanguage +
                "/Curtain/" +
                catID +
                "/" +
                SewingModelId +
                "/DraperyOnly" +
                "/Page-ID/" +
                WebsitePageItemId
              }
              className={`model_image_container 5`}
              onClick={() => sessionStorage.clear()}
            >
              <img
                src={getSelectionImageUrl(draperyPage0321)}
                className="img-fluid"
                alt=""
              />
            </Link>
            <div className={`model_info_container`}>
              <div className="model_item_info_container">
                <div className={`model_item_info_description_section`}>
                  {getSelectionTitle(draperyPage0321, "پرده پارچه\u200Cای", "Drapery")}
                </div>
                <Link
                  to={
                    "/" +
                    pageLanguage +
                    "/Curtain/" +
                    catID +
                    "/" +
                    SewingModelId +
                    "/DraperyOnly" +
                    "/Page-ID/" +
                    WebsitePageItemId
                  }
                  className="btn_normal model_item_btn_normal"
                  onClick={() => sessionStorage.clear()}
                >
                  {i18n.language === "fa" ? "مرحله بعدی" : "Continue"}
                </Link>
              </div>
            </div>
          </li>
        );
        modelLists[1] = (
          <li
            key={"model" + 2}
            model_id={2}
            className={`${2 % 2 === 0 ? "model_color_1" : "model_color_2"}`}
          >
            <Link
              to={
                "/" +
                pageLanguage +
                "/Curtain/" +
                catID +
                "/" +
                SewingModelId +
                "/SheersOnly" +
                "/Page-ID/" +
                WebsitePageItemId
              }
              className={`model_image_container 6`}
              onClick={() => sessionStorage.clear()}
            >
              <img
                src={getSelectionImageUrl(sheersPage0321)}
                className="img-fluid"
                alt=""
              />
            </Link>
            <div className={`model_info_container`}>
              <div className="model_item_info_container">
                <div className={`model_item_info_description_section`}>
                  {getSelectionTitle(sheersPage0321, "پرده تور", "Sheers")}
                </div>
                <Link
                  to={
                    "/" +
                    pageLanguage +
                    "/Curtain/" +
                    catID +
                    "/" +
                    SewingModelId +
                    "/SheersOnly" +
                    "/Page-ID/" +
                    WebsitePageItemId
                  }
                  className="btn_normal model_item_btn_normal"
                  onClick={() => sessionStorage.clear()}
                >
                  {i18n.language === "fa" ? "مرحله بعدی" : "Continue"}
                </Link>
              </div>
            </div>
          </li>
        );
        modelLists[2] = (
          <li
            key={"model" + 0}
            model_id={0}
            className={`${0 % 2 === 0 ? "model_color_1" : "model_color_2"}`}
          >
            <Link
              to={
                "/" +
                pageLanguage +
                "/Curtain/" +
                catID +
                "/" +
                SewingModelId +
                "/Drapery&Sheers" +
                "/Page-ID/" +
                WebsitePageItemId
              }
              className={`model_image_container 7`}
              onClick={() => sessionStorage.clear()}
            >
              <img
                src={getSelectionImageUrl(draperySheersPage0321)}
                className="img-fluid"
                alt=""
              />
            </Link>
            <div className={`model_info_container`}>
              <div className="model_item_info_container">
                <div className={`model_item_info_description_section`}>
                  {getSelectionTitle(
                    draperySheersPage0321,
                    "پرده تور و پارچه\u200Cای",
                    "Drapery & Sheers"
                  )}
                </div>
                <Link
                  to={
                    "/" +
                    pageLanguage +
                    "/Curtain/" +
                    catID +
                    "/" +
                    SewingModelId +
                    "/Drapery&Sheers" +
                    "/Page-ID/" +
                    WebsitePageItemId
                  }
                  className="btn_normal model_item_btn_normal"
                  onClick={() => sessionStorage.clear()}
                >
                  {i18n.language === "fa" ? "مرحله بعدی" : "Continue"}
                </Link>
              </div>
            </div>
          </li>
        );
      }
    }
    setModelList(modelLists);
  }

  useEffect(() => {
    if (
      pageLanguage !==
      location.pathname
        .split("")
        .slice(1, 3)
        .join("")
    ) {
      const tempLang = location.pathname.split("");
      setPageLanguage(tempLang.slice(1, 3).join(""));
      setModelList([]);
    }
  }, [location.pathname]);

  useEffect(() => {
    if (models.length) {
      renderModels();
    }
  }, [models]);

  useEffect(() => {
    if (pageLanguage !== "") {
      setTimeout(() => {
        getCats();
      }, 300);
    }
  }, [pageLanguage]);

  return (
    <div className={`Drapery_page_container ${pageLanguage === "fa" ? "font_farsi" : "font_en"}`}>
      <div className="models_title_div">
        <h1>
          {defaultModelName === undefined || defaultModelName === ""
            ? ""
            : pageLanguage === "fa"
            ? convertToPersian(defaultModelNameFa)
            : defaultModelName}
        </h1>
        <h2>{pageLanguage === "fa" ? defaultDescFa : defaultDesc}</h2>
      </div>
      <div className="cat_models_list_container">
        <hr />
        <ul className="cat_models_list_selection">{modelList}</ul>
      </div>
    </div>
  );
}

export default CurtainSelection;
